import React, { createContext, useState } from 'react';

const FormDataContext = createContext();

const FormDataProvider = ({ children }) => {
  const [formdataStore, setformdataStore] = useState({});
  const [stopbtnForStop,setstopbtnForStop]=useState(false)

  const value = {
    formdataStore,
    setformdataStore,
    stopbtnForStop,setstopbtnForStop
  };

  return <FormDataContext.Provider value={value}>{children}</FormDataContext.Provider>;
};

export { FormDataProvider, FormDataContext };
